import { styled } from "@l2r-front/l2r-ui"

import { IncidentFilters } from "../../containers/IncidentFilters"

export const MobileIncidentFilters = styled(IncidentFilters)({
    height: "100%",
    padding: "0px 36px 16px 36px",
    overflowY: "scroll",
})